import { HtmlHTMLAttributes } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons'

export type SortableRowProps = HtmlHTMLAttributes<HTMLTableRowElement> & {
  'data-row-key': string
  draggable: boolean
}

const SortableRow = (props: SortableRowProps) => {
  const id = props['data-row-key']
  const { setNodeRef, setActivatorNodeRef, transform, transition, attributes, listeners } = useSortable({
    id,
    data: { templateItemId: id }
  })

  const style: React.CSSProperties = {
    ...props.style,
    transition,
    transform: CSS.Transform.toString(transform),
  }

  const filteredProps = Object.fromEntries(Object.entries(props).filter(([k]) => k !== 'getData' && k !== 'draggable'))

  const isEmptyRow = (id === 'empty-row')

  if (!props.draggable) {
    return <tr {...filteredProps} style={style}>
      <td></td>
      {props.children}
    </tr>
  }

  return <tr {...filteredProps} ref={setNodeRef} style={style}>
    <td>
      {!isEmptyRow && <span ref={setActivatorNodeRef} style={{ fontSize: 18, cursor: 'move' }} {...attributes} {...listeners}><FontAwesomeIcon icon={faGripDotsVertical} /></span>}
    </td>
    {props.children}
  </tr>
}

export const DraggableSortableRow = (props: SortableRowProps) => <SortableRow {...props} draggable={true} />
export const NonDraggableSortableRow = (props: SortableRowProps) => <SortableRow {...props} draggable={false} />

const SortableHeader = (props: SortableRowProps) => {
  return <tr {...props}>
    <th></th>
    {props.children}
  </tr>
}
export const DraggableSortableHeader = (props: SortableRowProps) => <SortableHeader {...props} draggable={true} />
